<script>
  import { SPRITESHEET_URL } from '../../utils/constants.ts';

  let { 
    quote, 
    attribution, 
    attributionLine2, 
    source = undefined, 
    theme = 'light', 
    dataTestId = 'content-pull-quote' 
  } = $props();

  const longQuote = quote.split(' ').length > 40;
</script>

<blockquote
  cite={source}
  class="py-8 px-10 md:p-18 lg:py-18 lg:px-20 block w-full"
  data-testid={dataTestId}
  class:bg-blue-very-light={theme === 'light'}
  class:text-blue-dark-navy={theme === 'light'}
  class:bg-blue-dark-gray={theme === 'dark'}
  class:text-white={theme === 'dark'}
>
  <p
    class="relative mb-8 font-medium mx-auto"
    class:text-center={!longQuote}
    class:text-xl={!longQuote}
    class:md:text-3xl={!longQuote}
    class:text-lg={longQuote}
    class:md:text-1.5xl={longQuote}
  >
    <svg class="absolute -top-2 -left-10 lg:-left-12 h-8 w-8 lg:h-10 lg:w-10 fill-current text-blue-cerulean">
      <use xlink:href={`${SPRITESHEET_URL}#quote`} />
    </svg>
    {quote}
  </p>
  <footer
    class="text-lg md:text-xl leading-tight max-w-markdown mx-auto"
    class:text-center={!longQuote}
    class:text-blue-navy={theme === 'light'}
    class:text-white={theme === 'dark'}
  >
    {#if attributionLine2}
      <strong>
        {attribution}
      </strong>
      <div>{attributionLine2}</div>
    {:else}
      {attribution}
    {/if}
  </footer>
</blockquote>
